//export * from './Edit';

import { Edit } from "./Edit";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { withNotificationContext } from "js/notification-context";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core";
import styles from "./styles.js";

const enhance = compose(
  withApollo,
  withNotificationContext,
  withRouter,
  withStyles(styles)
);

//export default enhance(Edit);

export const EditNoticia = enhance(Edit);
